<div class="px-3 py-2">
	<h4 align="center">LA DE CIFRIS INCONTRA ROMA</h4>
	<p>Il giorno <b>4 ottobre 2018</b> si è tenuto a Roma il workshop organizzato 
		dal Dipartimento di Matematica e Fisica dell'Università Roma Tre con il 
		patrocinio della costituenda associazione nazionale di crittografia <i>De 
		</i>Componendis Cifris.</p>
	<b>Luogo: Università degli Studi di Roma Tre Aula Magna del Rettorato - 
		Via Ostiense 159</b>
	<p>
		Questa è la terza delle tre sessioni territoriali del 2018 e si propone di 
		offrire una panoramica sulle attività di ricerca a Roma e nel centro Italia, 
		riguardanti la Crittografia e le sue applicazioni. È stata inoltre l'occasione 
		per presentare l'iniziativa Nazionale "De Componendis Cifris".
		<br>
		L'iniziativa De Cifris di aggregazione delle competenze di Crittografia vuole 
		stimolare la collaborazione in ambito crittografico, coinvolgendo sia le numerose 
		eccellenze accademiche, che sono tuttora presenti in Italia, sia il mondo delle 
		Aziende che operano nel settore.
	</p>
	<p><a href="../../../../assets/eventi/2018/Roma/programma.pdf">Locandina</a></p>
	<h5>PROGRAMMA</h5>
	<ul>
		<li>
			<p><b>10:30 - 11:00  Registrazione partecipanti</b></p>
		</li>
		<li>
			<p><b>11:00 - 12:00  Sessione I</b></p>
			<ul class="ulSon">
				<li>
					<p>
						11:00 Prof. Paolo Atzeni - Università Roma Tre<br>
						<i>Prorettore con delega per la didattica</i>
					</p>
				</li>
				<li>
					<p>
						11:15 Prof. Massimiliano Sala - De Componendis Cifris<br>
						<a href="../../../../assets/eventi/2018/Roma/Slide_MSala.pdf">Acting Director</a>
					</p>
				</li>
				<li>
					<p>
						11:30 Dott.ssa Ebe Bultrini - Banca d'Italia<br>
						<a href="../../../../assets/eventi/2018/Roma/Slide_EBultrini.pptx"> Capo Dipartimento di Informatica</a>
					</p>
				</li>
				<li>
					<p>
						11:45 Dott.ssa Nunzia Ciardi - Polizia Postale<br>
						<i>Direttore</i>
					</p>
				</li>
			</ul>
		</li>
		<li>
			<p><b>12:00 - 12:15  Break</b></p>
		</li>
		<li>
			<p><b>12:15 - 13:00  Sessione II</b></p>
			<ul class="ulSon">
				<li>
					<p>
						12:15 Prof. Marco Pedicini - Università Roma Tre<br>
						<a href="../../../../assets/eventi/2018/Roma/Slide_MPedicini.pdf">Cosa la crittografia può fare per la privacy nell'ambito dei big data</a>
					</p>
				</li>
				<li>
					<p>
						12:30 Prof. Daniele Venturi - Università di Roma La Sapienza<br>
						<a href="../../../../assets/eventi/2018/Roma/Slide_DVenturi.pdf">Codici Non Malleabili e Applicazioni</a>
					</p>
				</li>
				<li>
					<p>
						12:45 Dott. Marco Liverani - NSR<br>
						<a href="../../../../assets/eventi/2018/Roma/Slide_MLiverani.pptx">Firma digitale: quanta complessità dietro ad un'operazione semplice</a>
					</p>
				</li>
			</ul>
		</li>
		<li>
			<p><b>13:00 - 13:45  Lunch break</b></p>
		</li>
		<li>
			<p><b>13:45 - 15:00  Sessione III</b></p>
			<ul class="ulSon">
				<li>
					<p>
						13:45 Paolo Menesatti - CREA, Davide Del Vecchio - Microsoft<br>
						<a href="../../../../assets/eventi/2018/Roma/Slide_PMenesatti-DDelVecchio.pdf">
							Un esempio di applicazione blockchain per la tracciabilità 
							elettronica del legno lungo tutta la sua filiera di trasformazione</a>
					</p>
				</li>
				<li>
					<p>
						14:00 Dott. Daniele Campli e Prof.ssa Dajana Cassioli, Università dell'Aquila<br>
						<a>NRoWE: a fair non-repudiation protocol harnessing extractable witness encryption</a>
					</p>
				</li>
				<li>
					<p>
						14:15 Dott. Roberto Civino - Università degli Studi dell'Aquila<br>
						<a href="../../../../assets/eventi/2018/Roma/Slide_RCivino.pdf">Some group theoretical aspects of block cipher security</a>
					</p>
				</li>
				<li>
					<p>
						14:30 Fabrizio Renzi - IBM Italia e Dott.ssa Cecilia Boschini - IBM Research - Zurich<br>
						<a href="../../../../assets/eventi/2018/Roma/Slide_FRenzi-CBoschini.pptx">
							The (post-quantum) future of data privacy</a>
					</p>
				</li>
				<li>
					<p>
						14:45 Prof. Marina Monsurrò - RNTA e Università Europea di Roma<br>
						<a href="../../../../assets/eventi/2018/Roma/Slide_MMonsurro.pdf">
							Una panoramica sulle attività della RNTA: promozione e diffusione 
							della teoria dei numeri e della crittografia nei paesi in via di sviluppo</a>
					</p>
				</li>
			</ul>
		</li>
		<li>
			<p><b>15:00 - 15:30 Coffe Break</b></p>
		</li>
		<li>
			<p><b>15:30 - 16:45  Sessione IV</b></p>
			<ul class="ulSon">
				<li>
					<p>
						15:30 Prof. Massimo Giulietti - Università degli Studi di Perugia<br>
						<a href="../../../../assets/eventi/2018/Roma/Slide_MGiulietti.pdf">
							Curve algebriche in Crittografia</a>
					</p>
				</li>
				<li>
					<p>
						15:45 Prof. Filippo Mignosi - Università degli Studi dell'Aquila<br>
						<a href="../../../../assets/eventi/2018/Roma/Slide_FMignosi.pdf">
							La Crittografia nella didattica dei corsi di teoria della complessità</a>
					</p>
				</li>
				<li>
					<p>
						16:00 Ing. Sergio Civino - Studio di Ingegneria Civino<br>
						<a href="../../../../assets/eventi/2018/Roma/Slide_IngCivino.pptx">
							Lo specialista d'informatica forense e l'hackeraggio etico</a>
					</p>
				</li>
				<li>
					<p>
						16:15 Pasquale Racca e Claudio Rosati - Armundia<br>
						<a href="../../../../assets/eventi/2018/Roma/Slide_PRacca-CRosati.pptx">
							Armundia e le ipotesi di impiego della Blockchain 
							nel mercato dell'intermediazione assicurativa e dell'advisory 
							finanziario</a>
					</p>
				</li>
				<li>
					<p>
						16:30 Sandro Fontana - GT50<br>
						<a href="../../../../assets/eventi/2018/Roma/Slide_SFontana.pdf">
							Problemi pratici nell'uso della blockchain nella notarizzazione documentale</a>
					</p>
				</li>
			</ul>
		</li>
		<li>
			<p><b>16:45 - 17:30 Questions & Answers, Closing Remarks, Networking</b></p>
		</li>
</ul>

</div>
  